import styled from 'styled-components'

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Preview = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  background-color: #ffffff;
  opacity: 1;
  background-image:
    repeating-linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%, lightgrey),
    repeating-linear-gradient(45deg, lightgrey 25%, #ffffff 25%, #ffffff 75%, lightgrey 75%, lightgrey);
  background-position:
    0 0,
    9px 9px;
  background-size: 18px 18px;
`

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp24} ${props => props.theme.spacing.sp32};
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.info.surface};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const ProductWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
`

export const ProductImageContainer = styled.div`
  position: relative;
`

export const ProductImage = styled.img`
  width: 100%;
  object-fit: cover;
`

export const WidgetScriptContainer = styled.div`
  display: none;
`
